import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { LeverageTypeDto } from '@model/LeverageTypeDto'
import { NameDto } from '@model/NameDto'
import { PlatformTypeEnum } from '@model/PlatformTypeEnum'

import { useLeverageOptions } from '../hooks/useLeverageOptions'

interface Props {
  restrictions?: NameDto[]
  currentLeverageId?: number | string
  platformTypeId?: PlatformTypeEnum | number
  title?: string
  onSelect: (leverage: LeverageTypeDto) => void
}

export const LeverageModal: BaseModalType<Props> = (props) => {
  const { close, restrictions = [], currentLeverageId, platformTypeId, title, onSelect } = props
  const { t } = useTranslation()

  const { leverages, leverageOptions, isLoading } = useLeverageOptions(
    platformTypeId,
    currentLeverageId,
    restrictions
  )

  const handleSelection = (selectedId: number) => {
    const selectedLeverage = leverages.find((l) => l.id === selectedId)

    if (selectedLeverage) {
      onSelect(selectedLeverage)
    }
    close()
  }

  return (
    <Modal>
      <Modal.Header>{title || t('Trading Account.Select Leverage')}</Modal.Header>
      <Modal.Body isLoading={isLoading}>
        <Modal.Body.Input.Radio
          value={currentLeverageId}
          name='leverage-radio-group'
          options={leverageOptions}
          onChange={handleSelection}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
